import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { focusOutline } from '@hivebrite/design-system/Theme';

import ReactionsIcon from './ReactionsIcon';

const ReactionsWrapper = styled(Box).attrs(({ px }) => ({
  alignItems: 'center',
  tabIndex: 0,
  px: px ?? 1,
}))`
  ${focusOutline}

  cursor: pointer;
  user-select: none;

  &:hover,
  &:focus {
    ${ReactionsIcon} {
      color: ${(props) => props.theme.colors.primary};
    }
  }
`;

export default ReactionsWrapper;
